<template>
    <div class="col-12" :id="code">
        <div class="form-group">
            <label v-if="label">{{$t(label)}}</label>
            <vue-dropzone :id="code"
                          :ref="code"
                          :options="dropZoneOptions"
                          @vdropzone-mounted="onDropZoneMounted"
                          :class="{'has-file': files.length > 0}">
            </vue-dropzone>
        </div>
    </div>
</template>

<script>
    import {BASE_API_UPLOAD} from '@/axios';
    import $ from 'jquery';
    import {clickImage} from '@/shared/utils';
    import {mapState} from "vuex";
    import {getArchiveModeDetailsByVersion} from "@/shared/archive-mode-utils";


    export default {
        props: {
            code: String,
            label: String,
            data: Array
        },
        computed: {
          ...mapState(['archiveModeVersion'])
        },
        data() {
            return {
                dropZoneOptions: {
                    url: BASE_API_UPLOAD + 'upload/save/new',
                    clickable: false,
                    dictDefaultMessage: this.$t('dropzone.defaultMessage'),
                    dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
                    dictCancelUpload: this.$t('dropzone.cancelUpload'),
                    dictCancelUploadConfirmation: this.$t('dropzone.cancelUploadConfirmation'),
                    dictRemoveFile: this.$t('dropzone.removeFile'),
                    dictRemoveFileConfirmation:  this.$t('dropzone.removeFileConfirmation')
                },
                files: [],
                files_added: []
            }
        },
        methods: {
            initFiles() {
                const dropZone = this.$refs[this.code];
                if (this.data && this.data.length > 0 && dropZone) {
                    this.data.forEach((file, index) => {
                        if (file && file.id && file.id > 0 && file.filePath && file.filePath.length > 0) {
                            if (!this.files_added.includes(file.id)) {
                                dropZone.manuallyAddFile(file, file.filePath);
                                this.files.push(file);
                                this.files_added.push(file.id);
                                var drop_zone_divs = $("#" + this.code + " > div.dz-preview .dz-image > img");
                                drop_zone_divs[index].setAttribute("url", file.filePath);
                            }
                        }
                    });
                    clickImage("#" + this.code);
                }
            },
            onDropZoneMounted() {
                this.initFiles();
            },
            updateDropzoneURL() {
              this.dropZoneOptions.url = (this.archiveModeVersion ? getArchiveModeDetailsByVersion(this.archiveModeVersion).url : BASE_API_UPLOAD) + 'upload/save/new';
              if(this.$refs[this.$props.code] && this.$refs[this.$props.code].dropzone && this.$refs[this.$props.code].dropzone.options) {
                this.$refs[this.$props.code].dropzone.options.url = (this.archiveModeVersion ? getArchiveModeDetailsByVersion(this.archiveModeVersion).url : BASE_API_UPLOAD) + 'upload/save/new'
              }
            }
        },
        watch: {
            // Watch for value change
            data: {
                immediate: true,
                // handle the changed value
                handler() {
                    this.initFiles();
                }
            }
        }
    }
</script>

<style>

</style>
